// The UI languages KitMaker supports, as a pure list: no i18next, no
// side effects. src/i18n.ts re-exports these (it also initialises i18next
// on import, which is why screens that only need the list - the admin
// "Mail test" language picker - import from here, and their tests can run
// with react-i18next mocked). The codes are the ones the locale folders,
// the API's mail language (MailLanguageResolver) and the language menu use:
// Norwegian is 'no', never 'nb'.
export type AppLanguage = 'en' | 'da' | 'nl' | 'de' | 'sv' | 'no' | 'es' | 'it' | 'fr' | 'pl'

export const SUPPORTED_LANGUAGES: ReadonlyArray<{ code: AppLanguage, label: string }> = [
  { code: 'en', label: 'English' },
  { code: 'da', label: 'Dansk' },
  { code: 'de', label: 'Deutsch' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'no', label: 'Norsk' },
  { code: 'pl', label: 'Polski' },
  { code: 'sv', label: 'Svenska' }
]

export const SUPPORTED_LANGUAGE_CODES: ReadonlyArray<AppLanguage> = SUPPORTED_LANGUAGES.map(l => l.code)

export function isAppLanguage (value: string | null | undefined): value is AppLanguage {
  return value != null && (SUPPORTED_LANGUAGE_CODES as ReadonlyArray<string>).includes(value)
}
